import styled from "styled-components";
import { Card, Row } from "react-bootstrap";
import { colors, types } from "../../../libs";

export const Wrapper = styled(Card)`
  padding: 20px;
  border-radius: 8px;
  text-align: left;
  background:  ${colors.background.black};
  padding: 20px;
  margin: 20px 0px;
  border: 1px solid ${colors.background.lightWhite};
  width: 100%;
`;

export const HeaderRow = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;
export const TicketInfoWrapper = styled.div`
  display: flex;
  align-items: center; 
  gap: 8px; 
`;

export const PriorityDot = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
`;

export const TicketId = styled.span`
   ${types.headers.small}
`;

export const PriorityTag = styled.span`
   ${types.body.small}
  background-color: ${colors.background.lightRed};
  color: red;
  padding: 4px 8px;
  border-radius: 4px;
`;

export const PostedAt = styled.span`
  ${types.body.small}
  color: ${colors.text.lightGray};
`;

export const TicketTitle = styled.div`
${types.body.normal}
  margin-bottom: 8px;
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis;
  width: 100%; 
`;

export const TicketDescription = styled.p`
   ${types.body.small}
  font-family: Montserrat, sans-serif;
  color: ${colors.text.lightGray};
  margin-bottom: 10px;
  line-height: 1.5;
   display: -webkit-box;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-height: 3em; 
`;

export const FooterRow = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${colors.background.lightWhite};
  padding-top: 10px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px; 
`;

export const IconPair = styled.div`
  display: flex;
  align-items: center;
  gap: 1px;
`;
export const MessageIconPair = styled(IconPair)`
  gap: 5px;
`;

export const ClientName = styled.span`
  ${types.body.normal}
  color:  ${colors.text.white};
`;

export const IconImage = styled.img`
  width: 17px;
  height: 17px;
`;

export const OpenTicketButton = styled.button`
  background: none;
  border: none;
  color: ${colors.text.green};
  ${types.body.normal}
  cursor: pointer;
`;
export const MessageInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const AttachmentInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
